export const sources={};export const img={src:"__VITE_ASSET__fB0sydq9LzIdCrzm1PcO1Q__",w:640,h:640};export default{sources:sources,img:img};